import { PPModal } from 'processor-plataform-ui';
import React, { useEffect, useState } from 'react';
import LcInfiniteTable from '../../../components/Data/LcInfiniteTable';
import LcLoading from '../../../components/Generic/LcLoading';
import LcIconLink from '../../../components/Generic/LcIconLink';
import { filterDefault } from '.';
import { Itens, LicenseNF, ParcelNF } from './Invoices.models';
import { useInvoiceDetails } from '../Hook/useInvoiceDetails';

interface NFDetailsModalProps {
    modalVisibleDetailsNF: boolean;
    nfSelected: any;
    filterItens:any;
    setModalVisibleDetailsNF: (value: boolean) => void;
}
var scope = {
    splitterStyle: {
        minHeight: 'calc(7vw)',
        fontSize: '11px'
    },
    splitterStyleSmall: {
        minHeight: 'calc(7vw)',
        fontSize: '11px'
    }
};
const columnsDetailsItensTable = [
    { field: 'id', headerName: 'Pn/SIP', width: "25%" },
    { field: 'description', headerName: 'Descrição', width: "35%" },
    { field: 'qtd', headerName: 'Quantidade', width: "10%", align: 'right' },
    {
        field: 'unitValue', headerName: 'Valor Unitário', width: "15%", align: 'right',
        renderCell: (row) => {
            return `R$ ${row.unitValue}`
        }
    },
    {
        field: 'totalValue', headerName: 'Valor Total', width: "15%", align: 'right',
        renderCell: (row) => {
            return `R$ ${row.totalValue}`
        }
    },
];

export const NFDetailsModal: React.FC<NFDetailsModalProps> = (props) => {
    const columnsOffer = [
        { field: 'chargeType', headerName: 'Tipo', width: "45%" },
        {
            field: 'chargeStartDate', headerName: 'Início', width: "15%", align: "right",
            renderCell: (row: any) => {
                return <div className="date">
                    {row.chargeStartDate ?
                        new Date(row.chargeStartDate).toLocaleDateString()
                        :
                        'Sem informação'}
                </div>
            }
        },
        {
            field: 'chargeEndDate', headerName: 'Vigência estimada', width: "15%", align: "right",
            renderCell: (row: any) => {
                return <div className="date">
                    {row.chargeEndDate ?
                        new Date(row.chargeEndDate).toLocaleDateString()
                        :
                        'Sem informação'}
                </div>
            }
        },
        {
            field: 'quantity', headerName: 'Quantidade', width: "10%", align: 'right'
        },
        {
            field: '', headerName: 'Valor Unitário ', width: "15%", align: 'right',
            renderCell: (row: any) => {
                return selectedProduct && `R$ ${Intl.NumberFormat([], {
                    style: 'decimal', currency: 'BRL',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(selectedProduct.totalValue / selectedProduct.qtd)}`
            }
        }
    ];
    const columnsLicenseItensColumns = [{
        field: 'dueDade', headerName: '', width: "5%",
        renderCell: (row: any) => {
            return <LcIconLink
                icon={`${row === selectedProduct ? 'ppi ppi-radiobtn-on' : 'ppi ppi-radiobtn'}`}
                color='var(--color-secondary-lime)'
                size='small'
                onClick={() => {
                    setSelectedProduct(row);
                }}
            />
        }
    },
    {
        field: 'productDescription', headerName: 'Selecione item para detalhamento', width: "85%",
        renderCell: (row) => {
            return <div
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    setSelectedProduct(row);
                }} > {row.productDescription}</div>
        }
    },
    { field: 'qtd', headerName: 'Quantidade', width: "10%", align: 'right' }

    ];

    const filterParcelNF: { size: number, term: string, column: string, direction: string } = (filterDefault);
    const [filterItens, setFilterItens] = useState<{ size: number, term: string, column: string, direction: string }>(filterDefault);
    const [selectedProduct, setSelectedProduct] = useState<LicenseNF | null>(null);
    const { data, isLoading } = useInvoiceDetails(props.nfSelected);
    const [visibleFilteredNFDetailsParcelNF, setVisibleFilteredNFDetailsParcelNF] = useState<ParcelNF[]>([]);
    const [visibleFilteredNFDetailsItens, setVisibleFilteredNFDetailsItens] = useState<Itens[]>([]);
    const [filteredNFDetailsParcelNF, setFilteredNFDetailsParcelNF] = useState<ParcelNF[]>([]);
    const [filteredNFNFLicensesItensVisible, setFilteredNFNFLicensesItensVisible] = useState<any[]>([]); 
    
    useEffect(() => {
        if (!data?.NFDetails) return;
        const sortedItens = [...(data.NFDetails.itens || [])].sort((a, b) => {
            if (filterItens.direction === 'asc') {
                return a[filterItens.column] > b[filterItens.column] ? 1 : -1;
            } else {
                return a[filterItens.column] > b[filterItens.column] ? -1 : 1;
            }
        });
        setVisibleFilteredNFDetailsItens(sortedItens.slice(0, filterItens.size));
        if (data.NFDetails.licenses?.length > 0) {
            setSelectedProduct(data.NFDetails.licenses[0]);
        } else {
            setSelectedProduct(null);
        }
        const sortedParcel = [...(data.NFDetails.parcelNF || [])].sort((a, b) => {
            if (filterParcelNF.direction === 'asc') {
                return a[filterParcelNF.column] > b[filterParcelNF.column] ? 1 : -1;
            } else {
                return a[filterParcelNF.column] > b[filterParcelNF.column] ? -1 : 1;
            }
        });
        setFilteredNFDetailsParcelNF(sortedParcel);
        setVisibleFilteredNFDetailsParcelNF(sortedParcel.slice(0, filterParcelNF.size));
        setFilteredNFNFLicensesItensVisible(data.filteredNFNFLicensesItens || []);
    
    }, [data, filterItens, filterParcelNF]);
    
    const loadMoreItens = (size?: number) => {
        if (size) setVisibleFilteredNFDetailsParcelNF(filteredNFDetailsParcelNF.slice(0, size))
        else {
            setVisibleFilteredNFDetailsParcelNF([...visibleFilteredNFDetailsParcelNF, ...filteredNFDetailsParcelNF.slice(visibleFilteredNFDetailsParcelNF.length, visibleFilteredNFDetailsParcelNF.length + 10)]);
        }
    };

    const loadMoreLicensesItens = (size?: number) => {
        if (data?.filteredNFNFLicensesItens && data?.filteredNFNFLicensesItens.length > 0) {
            if (size) setFilteredNFNFLicensesItensVisible(filteredNFNFLicensesItensVisible.slice(0, size));
            else {
                setFilteredNFNFLicensesItensVisible([...filteredNFNFLicensesItensVisible, ...filteredNFNFLicensesItensVisible.slice(filteredNFNFLicensesItensVisible.length, filteredNFNFLicensesItensVisible.length + 10)]);
            }
        }
    };

    const onSortChangeItens = (sortData: any) => {
        const { sort, size } = sortData;
        setFilterItens({ ...filterItens, column: sort.column, direction: sort.direction, size: size })
    };

    const onSortChangeLicensesItens = (sortData: any) => {
        if (filteredNFNFLicensesItensVisible && filteredNFNFLicensesItensVisible.length > 0) {
            const { sort, size } = sortData;
            setFilterItens({ ...filterItens, column: sort.column, direction: sort.direction, size: size });
        }
    };

    return (
        <PPModal size='large' visible={props.modalVisibleDetailsNF} title={`Detalhes da Nota Fiscal ${props.nfSelected.nfseId}`} onClose={() => props.setModalVisibleDetailsNF(false)}>

        {!(isLoading || !data) && <h4>Faturado Por: {(data?.NFDetails !== undefined)
            ? data?.NFDetails.company.name : "CANCELADO"}
            | CNPJ: {(data?.NFDetails !== undefined)
                ? data?.NFDetails.company.cnpj : "CANCELADO"}</h4>
        }
        <LcLoading label="Carregando dados.." loading={(isLoading || !data)} >
            {
                visibleFilteredNFDetailsItens.length > 0 &&
                <div style={scope.splitterStyleSmall}>
                    <LcInfiniteTable
                        columns={columnsDetailsItensTable}
                        rows={visibleFilteredNFDetailsItens}
                        size={visibleFilteredNFDetailsItens.length}
                        loadMore={loadMoreItens}
                        onSortChange={onSortChangeItens}
                    />
                </div>
            }
            <div style={scope.splitterStyle}>
                {
                    filteredNFNFLicensesItensVisible.length > 0 &&
                    <LcInfiniteTable
                        columns={columnsLicenseItensColumns}
                        rows={filteredNFNFLicensesItensVisible}
                        functions={[]}
                        size={filteredNFNFLicensesItensVisible.length}
                        loadMore={loadMoreLicensesItens}
                        onSortChange={onSortChangeLicensesItens}
                    />
                }

            </div>
            <div style={scope.splitterStyle}>
                {
                    selectedProduct && selectedProduct.offers && selectedProduct.offers.length &&
                    <>
                        <h3 style={{ marginTop: '30px' }}>Detalhamento - {selectedProduct.productDescription}</h3>
                        <LcInfiniteTable
                            rows={selectedProduct.offers}
                            columns={columnsOffer}
                            loadMore={() => { }}
                            size={selectedProduct.offers.length}
                        />
                    </>
                }
            </div>
        </LcLoading>
    </PPModal>
    );
}
